import { SVGProps } from 'react';

const Croissant = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.2 18H4.774a1.5 1.5 0 0 1-1.352-.97 11 11 0 0 1 .132-6.487M18 10.2V4.774a1.5 1.5 0 0 0-.97-1.352 11 11 0 0 0-6.486.132M18 5c1.06 0 2.078.316 2.828.879S22 7.204 22 8a2 2 0 0 1-2 2 10 10 0 0 0-5.139 1.42M5 18c0 1.061.316 2.078.879 2.828S7.204 22 8 22a2 2 0 0 0 2-2 10 10 0 0 1 1.42-5.14M8.709 2.554A10 10 0 0 0 2.554 8.71a1.5 1.5 0 0 0 .676 1.626l9.807 5.42a2 2 0 0 0 2.718-2.718l-5.42-9.807a1.5 1.5 0 0 0-1.626-.676"
    />
  </svg>
);
export default Croissant;
